import React, { useEffect } from 'react';
import styled from 'styled-components';
import {Card, CardActionButton} from '../elements';
import Widget from './widgetItem'
import { CONSTS } from '../elements/_constants';
import { AppState } from '../../store';
import { connect } from 'react-redux';
import { fetchDashboardData } from '../../store/base/functions';
import { QuickAccess } from '../../store/base/types';
type widgetsComponentProps = {
    className?: string,
    onFetchDashboardData: Function,
    quickAccess: QuickAccess[]
}
const WidgetsComponent = (props: widgetsComponentProps) => {
    useEffect(() => {
        props.onFetchDashboardData();
        return () => {};
    }, [])
    return(
        <div className={props.className}>
           <Card
            title="دسترسی سریع"
            headerMeta={<>
            {/* <CardActionButton title="ایجاد ویجت جدید" iconClassName="icon-icons8-plus_math" hasBorderRight={true}/> */}
            {/* <CardActionButton title="حذف ویجت‌ها" iconClassName="icon-icons8-trash" hasBorderRight={true}/> */}
            </>}
           />
            <div className="widget-items">
                {props.quickAccess.map(
                    (v,k)=>
                    <Widget key={k} to={`/categories/${v.category}/forms/${v.form}`} iconUrl={v.icon} title={v.title}/>
                )}
            </div>
        </div>
    )}

const Widgets = styled(WidgetsComponent)`
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
        margin: 0;
    }
    .widget-items {
        padding-bottom: 10px;
        width: calc(100% + 14px);
        margin-right: -7px;
        padding-top: 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        flex-flow: row wrap;
        align-items: flex-start;
        align-content: flex-start;
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) { 
            width: calc(100%);
            box-sizing: border-box;
            flex-direction: column;
        }
    }

`
const mapStateToProps = (state: AppState) => ({
    quickAccess: state.base.quickAccess
});
  
const mapDispatchToProps = (dispatch:any) => {
    return {
        onFetchDashboardData  : ()      =>{
            dispatch(fetchDashboardData());
        }
    };
};
    
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Widgets);